(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-hitch-gallery]').forEach(root => {
      if (root.dataset.hitchReady) return;
      root.dataset.hitchReady = 'true';
      const dialog = root.querySelector('.ehc-dialog');
      if (!dialog) return;
      let opener;
      root.addEventListener('click', event => {
        const photo = event.target.closest('[data-hitch-photo]');
        if (!photo || !root.contains(photo)) return;
        opener = photo;
        dialog.querySelector('img').src = photo.dataset.hitchPhoto;
        dialog.querySelector('img').alt = photo.dataset.hitchAlt || '';
        dialog.querySelector('p').textContent = photo.dataset.hitchAlt || '';
        dialog.showModal();
      });
      dialog.querySelector('.ehc-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({preventScroll:true}); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

